import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "operationFilter",

  initialState: {
    showTakasueBranches: true,
    showPickupDelivery: true,
    showNames: true
  },

  reducers: {
    setShowTakasueBranches: (state, { payload }) => {
      state.showTakasueBranches = payload;
    },
    setShowPickupDelivery: (state, { payload }) => {
      state.showPickupDelivery = payload;
    },
    setShowNames: (state, { payload }) => {
      state.showNames = payload;
    }
  }
});

export const {
  setShowTakasueBranches,
  setShowPickupDelivery,
  setShowNames
} = slice.actions;

export const operationFilterStore = (state) => state.operationFilter;

export default slice.reducer;
